export const EVENT = {
  Button: 'knop_interactie',
  Error: 'foutmelding',
  PageView: 'pageview',
} as const;
